// extracted by mini-css-extract-plugin
export default {"appGallery":"_mdvpbc"};